import type { CycleState } from "#shared/reviewCycleSchemas.ts";
import { Badge } from "@/components/ui/badge.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { reviewCyclesI18NextInstanceKey } from "../../../i18n/i18next.ts";

const INTENT_BY_STATE = {
    draft: "outline",
    scheduled: "warning",
    active: "success",
    locked: "secondary"
} as const satisfies Record<CycleState, "outline" | "warning" | "success" | "secondary">;

const DOT_CLASSNAME_BY_STATE = {
    draft: "bg-muted-fg",
    scheduled: "bg-warning",
    active: "bg-success",
    locked: "bg-muted-fg"
} as const satisfies Record<CycleState, string>;

export interface CycleStateDotProps {
    state: CycleState;
}

export function CycleStateDot({ state }: CycleStateDotProps) {
    return <span className={`size-2 shrink-0 rounded-full [[data-loading]_&]:hidden ${DOT_CLASSNAME_BY_STATE[state]}`} aria-hidden="true" />;
}

export interface CycleStateBadgeProps {
    state: CycleState;
}

export function CycleStateBadge({ state }: CycleStateBadgeProps) {
    const i18nextInstance = useI18nextInstance(reviewCyclesI18NextInstanceKey);
    const { t } = useTranslation("CycleStateBadge", { i18n: i18nextInstance });

    return (
        <Badge intent={INTENT_BY_STATE[state]} isCircle={false} className="[[data-loading]_&]:hidden">
            {t(state)}
        </Badge>
    );
}
